import pcbanglogo from './pcbanglogo.png'
import { lorem } from './util'
import galerie1 from './galerie1.png'
import galerie2 from './galerie2.png'
import galerie3 from './galerie3.png'
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

var ImageWithTitle = ({ containerStyle, src, className, imageStyle, title, desc }) => {
	return (
		<div
			className={'imagewithtitle ' + className}
			style={
				{
					backgroundImage: `url(${src})`,
					backgroundSize: "cover"
				}
			}
		>
			<div className="lowerbar">
				<div className="container">
					<div className="title">{title}</div>
					<div className="desc">{desc}</div>
				</div>
			</div>
		</div>
	);
}

ImageWithTitle.defaultProps = {
	alt: "",
	className: ""
}

const Galerie = () => {
	var stgs = {
		dots: false,
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1
	}
	return (
		<div className="galerie pagebody">
			<div className="mainbody">
				<div className="navpad"></div>
				<div className="hero title titles container">
					<img src={pcbanglogo} alt="" className="logo" />
					<div className="container headings">
						<h1 className="pcbang">PC BANG</h1>
						<h1 className="galerie">GALERIE</h1>
					</div>
				</div>
				<div className="content">
					{/* <img src="https://via.placeholder.com/500x450" alt="" className="image" /> */}
					{/* <ImageWithTitle src={"https://via.placeholder.com/500x450"} alt={"placeholder"}/> */}
					<div className="row container">
						<ImageWithTitle src={"idk"} alt={"placeholder"} title={lorem(50)} desc={lorem(50)} className="image1" />
						<div className="column container">
							<ImageWithTitle src={"https://via.placeholder.com/1920x1080"} alt={"placeholder"} title={lorem(50)} desc={lorem(50)} className="image2" />
							<ImageWithTitle src={"idk"} alt={"placeholder"} title={lorem(50)} desc={lorem(50)} className="image3" />
						</div>
					</div>
				</div>
				<div className="slideshow">
					<Slider {...stgs}>
						<img src={galerie3} alt="" className="slideshowimage" />
						<img src={galerie1} alt="" className="slideshowimage" />
						<img src={galerie2} alt="" className="slideshowimage" />
					</Slider>
				</div>
			</div>
		</div>

	);
}

export default Galerie;